var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-list',_vm._l((_vm.options),function(option){return _c('v-list-item',{key:option.id,on:{"click":function($event){return _vm.clickListItem(option.id)}}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v(_vm._s(option.icon))])],1),_c('v-list-item-title',[_vm._v(_vm._s(_vm._f("pluralize")(option.displayName,1)))])],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }